import BaseConfigApi from "../BaseConfigApi";

export default abstract class BaseForumApi extends BaseConfigApi {
	protected override getBaseUrl(params: Record<string, string>): string {
		return `${super.getBaseUrl(params)}/forum`;
	}
}
